<h1>Parameters</h1>

<app-viewer-parameters (parameterChange)="onParameterChange($event)"></app-viewer-parameters>

<hr />

<app-viewer-graphs [enrichedData]="enrichedData" [parameters]="parameters"></app-viewer-graphs>
